<template>
  <div>
    <CardBase>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <form
          class="form form-search"
          method="get"
          @submit.prevent="processExport"
        >

          <div class="form-search__row">
            <div class="form-search__double">
              <label class="form__label">Asset Group</label>
              <select
                class="form__input"
                v-model="formData.group_id"
                @change="setGroup"
              >
                <option value="" v-if="listGroup.length > 1" disabled>
                  Please Choose
                </option>
                <option value="" v-if="listGroupLoading">Please wait</option>
                <option v-for="row in listGroup" :key="row.id" :value="row.id">
                  {{ row.code_name }}
                </option>
              </select>
            </div>
            <div class="form-search__double">
              <label class="form__label">Asset</label>
              <multiselect
                v-model="formData.asset"
                :options="listAsset"
                :loading="listAssetLoading"
                :close-on-select="true"
                :hide-selected="false"
                track-by="id"
                label="name"
                :placeholder="
                  !formData.group_id
                    ? 'Please choose Asset Group'
                    : formData.asset
                    ? formData.asset.name
                    : 'All Asset'
                "
                :deselectLabel="'Remove selection'"
                :selectLabel="'Select this option'"
                @remove="resetDate"
                @input="
                  formData.asset_id = formData.asset ? formData.asset.id : ''
                "
              >
                <template #noOptions v-if="!formData.group_id"
                  >Please choose Asset Group</template
                >
                <template #noResult>No results found.</template>
              </multiselect>
            </div>
          </div>

          <div class="form-search__row">
            <div class="form-search__double">
              <label class="form__label">Start Date</label>
              <date-picker
                  v-model="formData.start_date"
                  type="date"
                  :editable="false"
                  :clearable="false"
                  input-class="form__input"
                  value-type="YYYY-MM-DD"
                  format="DD MMMM YYYY"
                  placeholder="Start Date"
                  @close="checkEndDate"
                  :disabled-date="notAfterToday"
              ></date-picker>
            </div>
            <div class="form-search__double">
              <label class="form__label">End Date</label>
              <date-picker
                  v-model="formData.end_date"
                  type="date"
                  :editable="false"
                  :clearable="false"
                  input-class="form__input"
                  value-type="YYYY-MM-DD"
                  format="DD MMMM YYYY"
                  placeholder="End Date"
                  :disabled-date="notBeforeStart"
              ></date-picker>
            </div>
          </div>

          <div class="form-search__row" v-if="!listAssetLoading">
            <div class="form-search__double">
              <label class="form__label">Transaction Type</label>
              <select class="form__input" v-model="formData.type_id">
                <option value="" disabled>Please Choose</option>
                <option value="1,2">Deposit + Withdraw</option>
                <option value="1">Deposit</option>
                <option value="2">Withdraw</option>
                <option value="3">Transfer</option>
              </select>
            </div>
            <div class="form-search__double" v-show="archivedNote">
              <label class="form__label">Archived {{ archivedNote }}</label>
              <select class="form__input" v-model="formData.archived">
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>
          </div>

          <div class="form-search__action" v-if="userCan('export.transaction')">
            <div class="w-4/12 flex">
              <BaseButton type="submit" class="mr-2" buttonClass="secondary"
                >Request Data</BaseButton
              >
            </div>
          </div>

          <div class="form-search__single mt-4">
            <FormNote class="mb-6"
            >Note: Jarak tanggal Start Date dan End Date
              <strong>maksimal 40 hari jika asset dipilih.</strong><br />Namun
              jika tidak memilih asset,
              <strong>hanya bisa export 7 hari saja.</strong></FormNote
            >
          </div>
        </form>
      </template>
    </CardBase>

    <CardBase class="mt-6" v-if="userCan('export.transaction')">
      <template #header>Download List</template>
      <template #toolbar
        ><BaseButton
          type="buton"
          class="mr-2"
          buttonClass="secondary"
          @click="loadTableData"
          >Refresh Table</BaseButton
        ></template
      >
      <template #content>
        <vue-good-table
          :key="tableKey"
          mode="remote"
          theme="polar-bear"
          :rows="tableData.rows"
          :columns="tableData.columns"
          :total-rows="tableData.totalRows"
          :isLoading="tableData.isLoading"
          :sort-options="{
            enabled: false,
          }"
          :pagination-options="{
            enabled: true,
            perPageDropdown: [100],
            dropdownAllowAll: false,
            setCurrentPage: tableData.currentPage,
            infoFn: tablePageInfo,
          }"
          styleClass="vgt-table striped bordered"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'expired_at'">
              <template v-if="props.row.status == 0"> - </template>
              <template v-else>
                {{ props.row.expired_at }}
              </template>
            </span>

            <span v-else-if="props.column.field == 'status'">
              <span
                class="flex items-start text-left"
                v-if="props.row.status == 0"
              >
                <template v-if="isNaN(props.row.progress)">
                  <font-awesome-icon
                    :icon="['fas', 'hourglass-half']"
                    class="text-yellow-500 mr-2"
                    size="lg"
                  />
                  {{ props.row.progress }}
                </template>
                <template v-else>
                  <div class="bg-gray-300 w-full">
                    <div class="bg-blue-400 h-4" :style="`width: ${props.row.progress}%`"></div>
                  </div>
                </template>
              </span>

              <a
                v-else-if="props.row.status == 1"
                :href="downloadLink + props.row.uuid"
                type="button"
                class="
                  w-full
                  border-green-500
                  button
                  border border-solid
                  hover:bg-green-500
                  hover:text-white
                  transition-all
                  duration-200
                  my-2
                  text-center text-green-500
                  cursor-pointer
                "
              >
                <font-awesome-icon :icon="['fas', 'check-circle']" />
                Download File
              </a>
            </span>
          </template>
        </vue-good-table>
      </template>
    </CardBase>
  </div>
</template>

<style lang="scss" scoped>
.swal2-actions button {
  display: none !important;
}
</style>
<script>
import { datePickerMixin } from "@/mixins/datePickerMixin";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import { showListMixin } from "@/mixins/showListMixin";

export default {
  data() {
    return {
      archivedNote: '',
      listAsset: [],
      listGroup: [],
      listGroupLoading: true,
      listAssetLoading: false,
      downloadUrl: "#",
      downloadReady: false,

      formData: {
        group_id: "",
        asset: null,
        asset_id: "",
        type_id: "",
        start_date: null,
        end_date: null,
        archived: 0,
      },

      tableData: {
        columns: [
          {
            label: "File",
            field: "title",
          },
          {
            label: "From",
            field: "from_date",
          },
          {
            label: "To",
            field: "to_date",
          },
          {
            label: "Requested By",
            field: "created_by",
          },
          {
            label: "Requested On",
            field: "created_at",
          },
          {
            label: "Expires On",
            field: "expired_at",
          },
          {
            label: "",
            field: "status",
            thClass: "vgt-table__action",
            tdClass: "vgt-table__action",
          },
        ],
      },
    };
  },
  mixins: [datePickerMixin, showListMixin],
  components: {
    DatePicker,
    Multiselect,
  },
  computed: {
    downloadLink: function () {
      return (
        process.env.VUE_APP_CDN_URL +
        "/export/" +
        this.$store.getters.getToken +
        "/"
      );
    },
  },
  created() {
    this.formData.start_date = this.moment(new Date()).format("YYYY-MM-DD");
    this.formData.end_date = this.moment(new Date()).format("YYYY-MM-DD");
    this.getListGroup();
  },
  methods: {
    loadTableData() {
      this.tableData.isLoading = true;
      this.tableData.limit = 100;
      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            `/export/member-transaction?page=${this.tableData.currentPage}&limit=${this.tableData.limit}`
        )
        .then((res) => {
          this.tableData.rows = res.data.data;
          this.tableData.totalRows = res.data.total;
          this.archivedNote = res.data.archived;
        })
        .finally(() => {
          this.tableData.isLoading = false;
        });
    },
    processExport() {
      if (!this.formData.group_id) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Please choose Asset Group.",
          icon: "warning",
        });
      } else if (!this.formData.type_id) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Please choose Transaction Type.",
          icon: "warning",
        });
      } else {
        this.$store.commit("toggleLoading");

        this.$swal({
          position: "bottom-end",
          preConfirm: false,
          showConfirmButton: false,
          toast: true,
          timer: 450000,
          timerProgressBar: true,
          title: "This may take awhile.. Please do not close this page.",
          icon: "warning",
        });

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "/export/member-transaction",
            this.formData
          )
          .then((res) => {
            const { message } = res.data;
            this.$swal.close();
            this.$swal({
              title: message,
              icon: "info",
            }).then(() => {
              this.loadTableData();
            });
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
          });
      }
    },
    getListGroup() {
      this.listGroupLoading = true;
      this.$http
        .get(process.env.VUE_APP_API_URL + "/group?central=1")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listGroup = response.data;

              if (this.listGroup.length == 1) {
                this.getListAsset(this.listGroup[0].id);
                this.formData.group_id = this.listGroup[0].id;
              }
            }
          }
        })
        .finally(() => {
          this.listGroupLoading = false;
        });
    },
    getListAsset(groupId = "") {
      this.listAssetLoading = true;
      this.formData.asset = null;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/profile/asset?group_id=" + groupId)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listAsset = response.data;
              const queryParams = this.$route.query;

              if (queryParams.asset_id != undefined) {
                this.listAsset.forEach((data) => {
                  if (data.id == queryParams.asset_id) {
                    this.formData.asset = data;
                  }
                });
              }
            }
          }
        })
        .finally(() => {
          this.listAssetLoading = false;
        });
    },
    setGroup() {
      this.formData.asset_id = "";
      this.getListAsset(this.formData.group_id);
    },
    notBeforeStart(date) {
      // End date must be < start and <= today
      const maxDays = this.formData.asset ? 40 : 7;

      let maxDate = new Date(this.formData.start_date);
      maxDate.setDate(maxDate.getDate() + maxDays);

      return (
        date <
          new Date(new Date(this.formData.start_date).setHours(0, 0, 0, 0)) ||
        date > maxDate ||
        date > new Date()
      );
    },
    resetDate() {
      const maxDays = 7

      const startDate = new Date(this.formData.start_date);

      let maxDate = startDate;
      maxDate.setDate(maxDate.getDate() + maxDays);

      this.formData.end_date = this.moment(maxDate).format("YYYY-MM-DD");
    },
    checkEndDate() {
      const maxDays = this.formData.asset ? 40 : 7;

      const startDate = new Date(this.formData.start_date);
      const endDate = new Date(this.formData.end_date);

      let maxDate = startDate;
      maxDate.setDate(maxDate.getDate() + maxDays);

      if (
        new Date(this.formData.start_date) >=
        new Date(new Date(this.formData.end_date).setHours(0, 0, 0, 0))
      ) {
        // If start > end, set end = start
        this.formData.end_date = this.formData.start_date;
      } else if (endDate > maxDate) {
        // If end > maxDays, set end = maxDate
        this.formData.end_date = this.moment(maxDate).format("YYYY-MM-DD");
      }
    },
  },
};
</script>